export const primary_color = '#5758BB';
export const primary_color_darker = '#454698';
export const text_color = '#263238';

export const text = {
  headingColor: '#263238'
};
